import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, EMPLOYEE_WORK_HOURS } from "../../../../Constants/Config";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  employeewrkhrstData: [],
  successMessage: "",
  error: "",
};

let abortEmployeeWrkHrs = null;

// Generate pening , fulfilled and rejected action type
export const fetchemployeewrkhrs = createAsyncThunk(
  "EmployeeWorkinghrsSlice/fetchemployeewrkhrs.",
  async (data, { rejectWithValue }) => {
    if (abortEmployeeWrkHrs) {
      abortEmployeeWrkHrs.abort();
    }

    abortEmployeeWrkHrs = new AbortController();
    const signal = abortEmployeeWrkHrs.signal;
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + EMPLOYEE_WORK_HOURS,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      if (response.data.status === true) {
        return response.data.report_data;
      } else {
        return response.data.report_data;
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
// Generate pening , fulfilled and rejected action type

const EmployeeWorkinghrsSlice = createSlice({
  name: "EmployeeWorkinghrsSlice",
  initialState,
  reducers: {
    updateStateOfEmployeeHours: (state) => {
      state.employeewrkhrstData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchemployeewrkhrs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchemployeewrkhrs.fulfilled, (state, action) => {
      state.loading = false;
      state.employeewrkhrstData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchemployeewrkhrs.rejected, (state, action) => {
      state.loading = false;
      state.employeewrkhrstData = {};
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfEmployeeHours } = EmployeeWorkinghrsSlice.actions;
export default EmployeeWorkinghrsSlice.reducer;
